// Pages current item
if ( jQuery('body').hasClass('page-id-230') ){
    jQuery('li.page-item-230').addClass('current_page_item')
}
